import { createGlobalStyle } from "styled-components"

import { colors } from "@izettle/otto"

import { fontsToLoad } from "@/core/assets/zen-fonts"

import {
  Content,
  LargeText,
  Title1,
  Title2,
  RegularText,
  RegularSecondaryText,
  SmallText,
  SmallSecondaryText,
  Button,
  AnchorButton,
  Input,
  LargeInputContainer,
} from "./core/components/shared"

const GlobalStyle = createGlobalStyle`
body {
  margin: 0;  
  background-color: #fafafa;
  font-family: Zen;

  &.ios.focus ${Content} {
    flex: none;
  }
  &:not(.ios.focus) ${Content} {
    transition-delay: 0.05s; // this will help untill the keyboard is hidden
  }

  &.ios {
    font: -apple-system-body;

    ${LargeText} {
      font-size: 1.7em;
      line-height: 1.25em;
    }
    ${Title1} {
      font-size: 1.7em;
      line-height: 1.25em;
    }
    ${Title2} {
      font-size: 1.25em;
      line-height: 1.2em;
    }
    ${RegularSecondaryText}, ${RegularText} {
      font-size: 0.85em!important;
      line-height: 1.5em;
    }
    ${SmallSecondaryText}, ${SmallText} {
      font-size: 0.75em!important;
      line-height: 1.4em!important;
    }
    ${Button} {
      font-size: 1.05em!important;
      line-height: 1.4em!important;
    }
    ${AnchorButton} {
      font-size: 1.05em!important;
      line-height: 1.4em!important;
      text-align: start;
      &.small {
        font-size: 0.75em!important;
      }
    }
    ${Input} {
      font-size: 1.7em!important;
      line-height: 1.25em;
    }
    ${LargeInputContainer} {
      label {
        font-size: 1.7em!important;
        line-height: 1.25em;
        &.up {
          font-size: 0.85em!important;
          line-height: 1.4em!important;
        }
      }
    }
  }
}
a {
  text-decoration: none;
}
[data-tooltip] {
  position: relative;
  cursor: pointer;
}

[data-tooltip]::after {
  font-family: Zen;
  font-size: 14px;
  position: absolute;
  opacity: 0;
  pointer-events: none;
  content: attr(data-tooltip);
  right: 16px;
  top: calc(100% + 10px);
  border-radius: 8px;
  background-color: ${colors.background.highlight};
  z-index: 10;
  padding: 12px 16px;
  width: 200px;
  transform: translateY(-20px);
  transition: all 150ms cubic-bezier(.25, .8, .25, 1);
  text-align: start;
}

[data-tooltip]::before {
  background-color: ${colors.background.highlight};
  content: "";
  position: absolute;
  top: calc(100% + 5px);
  right: 31px;
  transform-origin: left;
  transform: translateY(-13px) rotate(45deg);
  transition: all 150ms cubic-bezier(.25, .8, .25, 1);
  width: 10px;
  height: 10px;
  display: block;
  z-index: 10;
  opacity: 0;
}

[data-tooltip]:focus::after {
  opacity: 1;
  transform: translateY(0);
  transition-duration: 300ms;
}

[data-tooltip]:focus::before {
  opacity: 1;
  transform: translateY(-3px) rotate(45deg);
  transition-duration: 300ms;
}
${fontsToLoad}
`

export default GlobalStyle
